import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Checkbox } from "@/components/Checkbox/Checkbox";
import { classNames } from "@/utils/classNames";

import { Campaign } from "../../schema/campaign";

interface CampaignRowProps {
	campaign: Campaign;
	isSelected: boolean;
	onToggle: (campaignId: string) => void;
}

export const CampaignRow: FunctionComponent<CampaignRowProps> = ({
	campaign,
	isSelected,
	onToggle,
}) => {
	const { t } = useTranslation("translation", { keyPrefix: "list" });

	return (
		<div
			className={classNames(
				"flex items-center gap-2 h-11 pl-10 pr-3 cursor-pointer duration-200",
				isSelected ? "bg-selected-item" : "hover:bg-gray-100"
			)}
			data-test="copy-campaign-row"
			onClick={() => onToggle(campaign.id)}
		>
			<div className="w-5 flex-none">
				<Checkbox isChecked={isSelected} />
			</div>
			<span className="grow text-sm text-gray-900 truncate">{campaign.name}</span>
			<span
				className={classNames(
					"flex-shrink-0 text-xs font-medium px-2 py-0.5 rounded-full",
					campaign.isValid
						? "text-status-success bg-status-success-light"
						: "text-status-error bg-status-error-light"
				)}
			>
				{campaign.isValid ? t("copyCampaigns.valid") : t("copyCampaigns.invalid")}
			</span>
		</div>
	);
};
